import Dopa from './Dopa'

export default Dopa
